module.exports = __webpack_public_path__ + "img/Differentiation-PRCA_10X_AIC.a6c759bd.png";